import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import Page from '../../../enums/Page';
import PoweredByTHGIngenuityLogo from '../../../imgs/PoweredByTHGIngenuityLogo';
import THGCopyrightLogo from '../../../imgs/THGCopyrightLogo';
import RenderOn from '../../../UI/RenderOn/RenderOn';
import Language from '../../lang/language';
import Translation from '../../lang/Translation';
import getPage from '../../page/getPage';
import getLegalEntityForSelectedPaymentOption from '../../selectors/getLegalEntityForSelectedPaymentOption';
import isUsingArtemisStyles from '../../selectors/isUsingArtemisStyles';
import {getSettings, getSiteCode} from '../../selectors/selectors';
import paymentMethodsIdMap from './payment-method-id-map';
import Logo from './DynamicLogo';
import useStyles from './LegalEntity.styles';

export function LegalEntity(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  const legalEntityKeyLowercase = props.legalEntity?.legalEntityKey ? props.legalEntity.legalEntityKey.toLowerCase() : null
  const legalEntityTranslationKey = `checkout.footer.legal.entity.${legalEntityKeyLowercase}`
  const doesLegalEntityKeyExistInTranslations = props.legalEntity?.legalEntityKey
    && Language.doesTranslationExist(legalEntityTranslationKey)
  
  if (props.hideTHGFooter) {
    return null;
  }
  
  if (props.isFooterWithLogo) {
    return (
      <div className={classes.legalEntity} data-test="LegalEntity__withBrand">
        <RenderOn desktop>
          <Logo />
        </RenderOn>
        <div className={classes.staticTextContainer}>
          <p className={classes.allRightsReservedText} data-test="LegalEntity__terms">
            <Translation optionalExtension={props.siteCode}>footer.subject.to.tnc</Translation>
          </p>
          <p className={classes.allRightsReservedText} data-test="LegalEntity__copyrightCompany">
            <Translation optionalExtension={props.siteCode}>footer.copyright.company</Translation>
          </p>
          <p className={classes.allRightsReservedText} data-test="LegalEntity__copyrightAddress">
            <Translation optionalExtension={props.siteCode}>footer.copyright.address</Translation>
          </p>
        </div>
        <RenderOn desktop>
          <PoweredByTHGIngenuityLogo />
        </RenderOn>
      </div>
    )
  }
  
  if (doesLegalEntityKeyExistInTranslations) {
    return (
      <div className={classes.legalEntity} data-test="LegalEntity">
        <>
          {props.hasPoweredByLabel && (
            <p className={classes.corporateText} data-test="LegalEntity__label">
              <Translation>powered.by</Translation>
            </p>
          )}
          <p className={classes.corporateText} data-test="LegalEntity__translation">
            <Translation optionalExtension={props.siteCode}>{legalEntityTranslationKey}</Translation>
          </p>
        </>
      </div>
    )
  }
  
  if (props.legalEntity) {
    return (
      <div className={classes.legalEntity} data-test="LegalEntity">
        <>
          {props.hasPoweredByLabel && (
            <p className={classes.corporateText} data-test="LegalEntity__label">
              <Translation>powered.by</Translation>
            </p>
          )}
          <p className={classes.corporateText} data-test="LegalEntity__companyName">
            {props.legalEntity.companyName}
          </p>
          <p className={classes.corporateText} data-test="LegalEntity__address">
            {props.legalEntity.address}
          </p>
        </>
      </div>
    )
  }
  
  return (
    <div className={classes.legalEntity} data-test="LegalEntity">
       <THGCopyrightLogo />
    </div>
  );
}

const mapStateToProps = (state) => {
  const page = getPage();
  const settings = getSettings(state);
  const entities = state.start.legalEntities && state.start.legalEntities.entities;
  const oldEntity = entities ? entities[paymentMethodsIdMap(state.payment.paymentOptionName)] : null;
      const newEntity = getLegalEntityForSelectedPaymentOption(state);
      return {
      siteCode: getSiteCode(state),
      isFooterWithLogo: !!settings.is_footer_with_logo,
      isUsingArtemisStyles: isUsingArtemisStyles(state),
      hasPoweredByLabel: settings.powered_by_label,
      legalEntity: settings.enable_adyen_v2_legal_entity ? newEntity : oldEntity,
      hideTHGFooter: settings.hide_thg_footer
      || ((page === Page.COMPLETE
      || page === Page.PAYMENT_CHANGED
      || page === Page.PAYMENT_RESOLVED)
      && settings.hide_complete_page_thg_footer),
    };
    };
      
      LegalEntity.propTypes = {
      siteCode: PropTypes.string,
      isUsingArtemisStyles: PropTypes.bool,
      isFooterWithLogo: PropTypes.bool,
      legalEntity: PropTypes.object,
      hasPoweredByLabel: PropTypes.bool,
      hideTHGFooter: PropTypes.bool,
    };
      
      LegalEntity.defaultProps = {
      legalEntity: undefined,
      hideTHGFooter: false,
      hasPoweredByLabel: false,
    };
      
      export default connect(
      mapStateToProps,
      )(LegalEntity);
